import ApplicationController from './application_controller'

class PeriodSelectController extends ApplicationController {
  connect() {
    const form = this.element.form

    const prevButton = form.querySelector("#period-prev")
    const nextButton = form.querySelector("#period-next")

    prevButton?.addEventListener('click', (e) => {
      const nextOption = selectedPeriod.nextElementSibling
      this.element.value = nextOption.value
      this.element.dispatchEvent(new Event('change'))
    })

    nextButton?.addEventListener('click', (e) => {
      const prevOption = selectedPeriod.previousElementSibling;
      this.element.value = prevOption.value
      this.element.dispatchEvent(new Event('change'))
    })

    this.element.addEventListener('change', (e) => {
      let startDate = selectedPeriod.data('startDate')
      let endDate = selectedPeriod.data('endDate')
      let detailed = selectedPeriod.data('detailed')

      if (startDate && endDate) {
        form.append("<input name='start_date' type='hidden' value='" + startDate + "'/>")
        form.append("<input name='end_date' type='hidden' value='" + endDate + "'/>")
        form.append("<input name='detailed' type='hidden' value='" + detailed + "'/>")
      }

      form.trigger('submit')
    })
  }

  get selectedPeriod() {
    this.element.querySelector('option:selected')
  }

  serSelectedPeriod(value) {
    this.element.value = value
    this.element.dispatchEvent(new Event('change'))
  }
}

export default PeriodSelectController
